// ets_tracing: off
import { first as AssociativeFirst } from "@effect-ts/core/Associative";
import { difference, Foldable as foldableArray, intersection, reduceRight } from "@effect-ts/core/Collections/Immutable/Array";
import { fromFoldable } from "@effect-ts/core/Collections/Immutable/Dictionary";
import { tuple } from "@effect-ts/core/Collections/Immutable/Tuple";
import * as Equal from "@effect-ts/core/Equal";
import * as CU from "./ctors/index.mjs";
import * as Ma from "./matcher/index.mjs";
import * as M from "./monocle/index.mjs";
import * as PU from "./predicates/index.mjs";

const mergeKeys = (a, b) => ({ ...a,
  ...b
});

const recordFromArray = /*#__PURE__*/fromFoldable( /*#__PURE__*/AssociativeFirst(), foldableArray);

const toTupleNull = k => tuple(k, null);

const intersectKeys = (a, b) => recordFromArray(intersection(Equal.string)(Object.keys(b))(Object.keys(a)).map(toTupleNull));

const excludeKeys = (a, toRemove) => recordFromArray(difference(Equal.string)(toRemove)(Object.keys(a)).map(toTupleNull));

const keepKeys = (a, toKeep) => recordFromArray(intersection(Equal.string)(toKeep)(Object.keys(a)).map(toTupleNull));

export const unionADT = as => {
  const newKeys = reduceRight(as[0].keys, (x, y) => mergeKeys(x.keys, y))(as);
  return makeADT(as[0].tag)(newKeys);
};
export const intersectADT = (a, b) => makeADT(a.tag)(intersectKeys(a.keys, b.keys));
export const ofType = () => 1;
export const makeADT = tag => _keys => {
  const keys = _keys; // any

  const ctors = CU.Ctors(tag)(keys);
  const predicates = PU.Predicates(tag)(keys);
  const monocles = M.MonocleFor();
  const matchers = Ma.Matchers(tag)(keys);

  const select = selectedKeys => makeADT(tag)(keepKeys(keys, selectedKeys));

  const exclude = excludedKeys => makeADT(tag)(excludeKeys(keys, excludedKeys));

  const res = { ...ctors,
    ...predicates,
    ...monocles,
    ...matchers,
    tag,
    keys,
    select,
    exclude
  };
  return res;
};
//# sourceMappingURL=index.mjs.map